module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-p-500-b12d1e670a65810feb260244de1aec42.png";